module.exports = __webpack_public_path__ + "img/profile.10a377c1.svg";